/*************************************************/
/* BASM RESALE                                   */
/*************************************************/

export function basmResale() {
    const resaleButtonSelector = '.basm_resale_browse_btn';

    const showResaleButtons = () => {
        if (window.basm?.configuration?.resaleEnabled !== true) return;

        document.querySelectorAll(resaleButtonSelector).forEach(button => {
            button.style.display = '';
        });
    };

    const init = () => {
        if (!document.querySelector(resaleButtonSelector)) return;

        if (window.basm?.configuration) {
            showResaleButtons();
        } else {
            window.addEventListener('init.basm', showResaleButtons, { once: true });
        }
    };

    init();
}
